import {useState, useEffect} from 'react';
import PharmaorderInfoForView from 'components/pharmaorder/PharmaorderInfoForView';
import ProductListByOrderId from '../../components/vieworder/ProductListByOrderId';

export default function VieworderActionImpl(){

    return (
        <>
        <PharmaorderInfoForView/>
        <ProductListByOrderId/>
        </>
    )
}